/**
 * 客户端热点
 */
"use strict";
angular.module("appChannelHotSpotsModule", ['hotSpotsTopModule', 'timeHotSpotsTimeLineModule', 'relateManuscriptsModule']).
controller("appChannelHotSpotsCtrl", ["$scope", "trsHttpService", "$q", "hotFocusService", function($scope, trsHttpService, $q, hotFocusService) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {

        }

        $scope.data = {
            appCountryHSList: [], // app全国热点
            appAreaHSList: [], // app地域热点
            curAppHotSpotManu: {}, // 当前app地域热点
            curAppHotSpotDetail: {}, // 当前app热点详细
            relateManuList: [], //相关稿件
            timeAppLineList: [], //
        }
        $scope.relateListPage = {
            pageno: '1',
            pagesize: '20'
        }
    }

    function initData() {
        $scope.loadingPromise = $q.all([reqAppCountryTop(), reqAppAreaTop()]).then(function(data) {
            //默认取值全国热点的第一个
            if (data[0].CONTENTS  && data[0].CONTENTS.length > 0) {
                $scope.data.curAppHotSpotManu = $scope.data.appCountryHSList[0];
                reqManuscriptDetail();
                reqAppPulishTimeLine(); // 客户端发版
                reqRelevantManuData();
                return;
            }
            //如果全国热点为空，则默认取区域热点的第一个
            if (data[1].CONTENTS  && data[1].CONTENTS.length > 0) {
                $scope.data.curAppHotSpotManu = $scope.data.appAreaHSList[0];
                reqManuscriptDetail();
                reqAppPulishTimeLine(); // 客户端发版
                reqRelevantManuData();
            }
        });
    }

    /**
     * [requestAppCountryTop description]客户端全国热点TOP10
     * @return {[type]} [description]
     */
    function reqAppCountryTop() {
        var defer = $q.defer();
        var params = {
            typeid: "widget",
            serviceid: "channelhot",
            modelid: "getAppHotList",
            areaflag: 1,
            pagesize: '10',
            pageno: '1'
        };
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            if (data.STATUS && data.STATUS == 'success') {
                if (data.CONTENTS.length > 0) {
                    data.CONTENTS.forEach(function(val, idx) {
                        val.GUID = val.mainGuid;
                        val.TITLE = val.title;
                    })
                    $scope.data.appCountryHSList = data.CONTENTS;
                }
            }
            defer.resolve(data);
        });
        return defer.promise;
    }

    /**
     * [reqAppAreaTop description]客户端地域热点TOP10
     * @return {[type]} [description]
     */
    function reqAppAreaTop() {
        var defer = $q.defer();
        var params = {
            typeid: "widget",
            serviceid: "channelhot",
            modelid: "getAppHotList",
            areaflag: 2,
            pagesize: '10',
            pageno: '1'
        };
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            if (data.STATUS && data.STATUS == 'success') {
                data.CONTENTS.forEach(function(val, idx) {
                    val.GUID = val.mainGuid;
                    val.TITLE = val.title;
                })
                $scope.data.appAreaHSList = data.CONTENTS;
            }
            defer.resolve(data);
        });
        return defer.promise;
    }

    /**
     * [countryTopCallback description]全国热点TOPcallback
     * @return {[type]} [description]
     */
    $scope.clickTopCallback = function() {
        reqManuscriptDetail();
        reqAppPulishTimeLine(); // 客户端发版
        reqRelevantManuData();
    }

    /**
     * [reqManuscriptDetail description]稿件详情
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    function reqManuscriptDetail(data) {
        var params = {
            typeid: "widget",
            serviceid: "channelhot",
            modelid: "getAppHotDetail",
            GUID: $scope.data.curAppHotSpotManu.mainGuid
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.STATUS && data.STATUS == 'success') {
                $scope.data.curAppHotSpotDetail = data.CONTENTS[0];
            }
        });
    }

    /**
     * [reqAppPulishTimeLine description]客户端发布时间轴
     * @return {[type]} [description]
     */
    function reqAppPulishTimeLine(data) {
        var params = {
            typeid: "widget",
            serviceid: "channelhot",
            modelid: "getAppHotDocsTimeLine",
            guids: data ? data.docGuids : $scope.data.curAppHotSpotManu.docGuids
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.STATUS && data.STATUS == 'success') {
                $scope.data.timeAppLineList = data.CONTENT;
            }
        });
    }

    /*
     * [reqRelevantManuData description]请求相关稿件
     */
    function reqRelevantManuData() {
        var params = {
            typeid: "widget",
            serviceid: "channelhot",
            modelid: "getRelevantDocs",
            pageno: $scope.relateListPage.pageno,
            pagesize: $scope.relateListPage.pagesize,
            keywords: $scope.data.curAppHotSpotManu.keywords,
            guid: $scope.data.curAppHotSpotManu.mainGuid,
            sitename: $scope.data.curAppHotSpotManu.sitename
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.STATUS && data.STATUS == 'success') {
                $scope.data.relateManuList = data.CONTENTS;
                $scope.relateListPage = {
                    pageno: data.PAGENO,
                    pagesize: data.PAGESIZE,
                    totalnum: data.TOTALNUM,
                    totalpages: data.TOTALPAGES
                };
                if ($scope.data.relateManuList.length <= 0) { // 如果长度为0，pageno重置为1
                    $scope.relateListPage.pageno = '1';
                }
            }
        });
    }

    /**
     * [relateManuCallback description]相关稿件list回调
     * @return {[type]} [description]
     */
    $scope.relateManuCallback= function() {
        reqRelevantManuData();
    }

}]);